module.exports = __webpack_public_path__ + "img/women_minified.2dc9fa3e.jpg";